import React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import Event from '@mui/icons-material/Event';
import { google, outlook, office365, yahoo, ics } from 'calendar-link';
import { ChevronDown } from 'mdi-material-ui';

const AddToCalendar = ({ event, iconOnly }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (e) => {
    setAnchorEl(e.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const buttonProps = {
    edge: 'start',
    color: 'primary',
    size: 'small',
    'aria-label': 'Add to calendar',
    id: 'add-to-calendar-button',
    'aria-controls': 'add-to-calendar-menu',
    'aria-haspopup': true,
    'aria-expanded': open ? 'true' : undefined,
    onClick: handleClick,
  };

  if (!event) {
    return <Event />;
  }

  const [, startTime] = `${event?.date}`?.split('T');

  const relevantEventDate = {
    description: `Added through ZIKI.FM. HAVE A GREAT TIME!<br><br>P.S I purposefully put this as an "all-day" event as times can be deceptive - the time we get for an event could be for doors open or the band starting for example and would not want to show an incorrect time.<br><br> This is the time we have down for this event: ${startTime}`,
    start: event.date,
    title: `${event.artist} - ${event.name}`,
    location: event.location,
    allDay: true,
  };

  return (
    <div>
      {iconOnly ? (
        <Tooltip title="Add to calendar">
          <IconButton {...buttonProps}>
            <Event />
          </IconButton>
        </Tooltip>
      ) : (
        <Button
          sx={{ mt: 1, mb: 1 }}
          {...buttonProps}
          startIcon={<Event />}
          endIcon={<ChevronDown />}
        >
          Add to calendar
        </Button>
      )}
      <Menu
        id="add-to-calendar-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem component="a" target="_blank" href={google(relevantEventDate)}>
          Google Calendar
        </MenuItem>
        <MenuItem component="a" target="_blank" href={outlook(relevantEventDate)}>
          Outlook
        </MenuItem>
        <MenuItem component="a" target="_blank" href={yahoo(relevantEventDate)}>
          Yahoo
        </MenuItem>
        <MenuItem component="a" target="_blank" href={ics(relevantEventDate)}>
          ICS file / Apple
        </MenuItem>
        <MenuItem component="a" target="_blank" href={office365(relevantEventDate)}>
          Office 365
        </MenuItem>
      </Menu>
    </div>
  );
};

export default AddToCalendar;
